// extracted by mini-css-extract-plugin
export default {"faqView":"FaqView_faqView__x5ax2"};